import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/components/footer/index.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/components/header/index.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/i18n.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/styles/globals.css");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[lang]/styles/markdown.scss")